import { ISlot } from '../../../uanc.types';
import { AD_SERVERS } from '../../../configs/constants';
import { IAOServiceSlot } from './service-adocean.types';

/**
 * Przygotowuje obiekt konfiguracji slotu AdOcean na podstawie obiektu otrzymanego z ADC. Uzupełnia brakujące pola, waliduje.
 *
 * @param {ISlot} slot - slot
 * @returns {ISlot} pełna konfiguracja slotu
 */
export const prepareSlotAdOcean = (slot: ISlot): IAOServiceSlot => {
    const commonFields = {
        name: slot.name,
        adServer: AD_SERVERS.ADOCEAN,
        disable: slot.disable ?? false,
        isLazyLoading: slot.isLazyLoading ?? false,
        isTest: slot.isTest ?? false,
        slotid: slot.slotid,
    };

    return {
        ...commonFields,
        renderedPlacements: null,
        placementIds: [`ad-${slot.name}`],
        loadingTime: Date.now(),
        refreshed: 0,
    };
};
